import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ContractTerminationReasonService } from 'src/app/shared/store/contract-termination-reason/contract-termination-reason.service';
import { SubHeaderService } from 'src/app/shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { filter, Observable } from 'rxjs';
import { View } from '../../../../shared/store/view/types';
import { take } from 'rxjs/operators';
import { FormService } from '../../../../shared/store/form/form.service';

@UntilDestroy()
@Component({
  selector: 'app-contract-termination-reason-create',
  templateUrl: './contract-termination-reason-create.component.html',
  styleUrls: ['./contract-termination-reason-create.component.scss'],
  standalone: false,
})
export class ContractTerminationReasonCreateComponent
  implements OnInit, OnDestroy
{
  view$: Observable<View>;

  contractTerminationReasonForm: FormGroup;

  constructor(
    private readonly contractTerminationReasonService: ContractTerminationReasonService,
    private readonly router: Router,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly formService: FormService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'contractTerminationReasonCreate') this.onSubmit();
        if (x == 'contractTerminationReasonList') {
          this.formService.clear();
          this.router.navigate(['Insurance/ContractTerminationReasons/']);
        }
        this.subHeaderService.setTriggerAction('');
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
        this.breadcrumbService.set(
          '@contractTerminationReasonCreate',
          x.breadcrumbCreate,
        );
      });

    this.contractTerminationReasonForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(200)]],
      active: [true],
    });
  }

  onSubmit() {
    if (this.contractTerminationReasonForm.invalid) {
      this.contractTerminationReasonForm.markAllAsTouched();
      this.formService.countErrors(this.contractTerminationReasonForm, true);
      return;
    }

    this.formService.clear();

    let result$ = this.contractTerminationReasonService.add.call({
      id: 0,
      name: this.contractTerminationReasonForm.value.name!,
      active: this.contractTerminationReasonForm.value.active!,
    });

    result$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((result) => {
        this.router.navigate([
          '/Insurance/ContractTerminationReasons/Details',
          result.id,
        ]);
      });
  }

  ngOnDestroy(): void {
    this.contractTerminationReasonService.add.reset();
  }
}
